import { Link } from "react-router-dom";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import type { Article } from "@/types";
import { SafeImage } from "@/components/ui/SafeImage";

interface ArticleCardProps {
  article: Article;
  /** Mark as LCP candidate — loads image eagerly with fetchpriority="high" */
  priority?: boolean;
}

export function ArticleCard({ article, priority = false }: ArticleCardProps) {
  return (
    <Link to={`/article/${article.slug}`} className="group flex flex-col gap-4">
      <article className="flex flex-col h-full bg-card group-hover:-translate-y-1 transition-transform duration-300">
        <div className="relative aspect-[16/10] overflow-hidden rounded-2xl w-full border border-border/50 bg-muted mb-4 shadow-sm group-hover:shadow-md transition-shadow">
          <SafeImage
            src={article.coverImage || ""}
            alt={article.title}
            priority={priority}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>

        <div className="flex-1 flex flex-col px-1">
          <p className="text-xs font-semibold tracking-wider text-muted-foreground uppercase mb-2">
            {format(article.createdAt, "d MMM yyyy", { locale: fr })}
            {article.readingTime && (
              <span className="font-normal capitalize italic">
                {" "}· {article.readingTime} min lecture
              </span>
            )}
          </p>
          <h2 className="text-xl font-bold leading-tight group-hover:text-primary/80 transition-colors line-clamp-2">
            {article.title}
          </h2>
          <p className="text-sm text-muted-foreground mt-2 leading-relaxed line-clamp-3">
            {article.excerpt}
          </p>
        </div>
      </article>
    </Link>
  );
}
